import React from 'react';
import { Row, Col } from 'react-bootstrap';
import ErrorAlert from './ErrorAlert';
import StudentSearch from './StudentSearch';
import ClassSelection from './ClassSelection';
import CheckInButton from './CheckInButton';
const CheckInForm: React.FC = () => {

  return (
    <Row className="flex-grow-1 justify-content-center align-items-start py-5 px-3" >
      <Col xs={12} md={12} lg={12}>
        <ErrorAlert />
        <StudentSearch />
        <ClassSelection />
        <CheckInButton />
      </Col>
    </Row>
  );
};

export default CheckInForm;